import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

export interface Props {
  PalavraChave?: string;
  tipoFiltroData?: number | null;
  dataInicio?: string;
  dataFim?: string;
  PaginaAtual?: number;
  TotalItensRetorno?: number;
  Etapa: string;
  SubEtapa: string[];
  Comercial: boolean;
  queryKey?: string;
  codigo: string;
  IdEmpreendimento: string[];
  IdBloco?: string;
  IdUnidade?: string;
  IdsOrigens?: string[];
  IdSuperintendente365?: string;
  IdGerente365?: string;
  IdCorretor365?: string;
  Compartilhadas?: boolean;
  compartilhar?: boolean;
}

export function usePropostasListarKanban(props: Props) {
  const fetchData = async () => {
    const LISTAR_KANBAN = `${backofficeEnviroment}/common/backoffice/kanban/v2/${props.codigo}`;

    const subEtapasToNumber = (props.SubEtapa || [])
      .map((subEtapa) => Number(subEtapa))
      .filter((subEtapa) => Number.isFinite(subEtapa));

    const hasDateFilter =
      props.tipoFiltroData !== null &&
      props.tipoFiltroData !== undefined &&
      !!props.dataInicio &&
      !!props.dataFim;

    const payload = {
      Etapa: props.Etapa || "",
      Comercial: props.Comercial,
      PalavraChave: props.PalavraChave || "",
      tipoFiltroData: hasDateFilter ? props.tipoFiltroData : undefined,
      dataInicio: hasDateFilter ? props.dataInicio : undefined,
      dataFim: hasDateFilter ? props.dataFim : undefined,
      SubEtapa: subEtapasToNumber,
      IdEmpreendimento: props.IdEmpreendimento || [],
      IdBloco: props.IdBloco || undefined,
      IdUnidade: props.IdUnidade || undefined,
      IdsOrigens: props.IdsOrigens || [],
      IdSuperintendente365: props.IdSuperintendente365 || undefined,
      IdGerente365: props.IdGerente365 || undefined,
      IdCorretor365: props.IdCorretor365 || undefined,
      Compartilhadas: props.Compartilhadas ?? props.compartilhar ?? false,
      PaginaAtual: props.PaginaAtual || 1,
      TotalItensRetorno: props.TotalItensRetorno || 3,
    };

    const response = await instance.post(LISTAR_KANBAN, payload);

    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: true,
    retry: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar produtos. Motivos:\n ${error.response.data.notifications?.map(
          (item: any) => `${item?.message}`
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
